import { useQuery } from "react-query";

import { adminApis, queryKeys } from "./index";

export const useScratchTotal = () => {
  return useQuery([queryKeys.MEGASCRATCH_TOTAL], adminApis.getScratchTotal);
};
